import { TableHeader as HeroUiTableHeader } from '@heroui/table';

export const TableHeader = HeroUiTableHeader;
